<template>
  <div class="w-12">
    <ul>
      <li class="mb-2">
        <button
          ghost
          class="w-12 h-12 leading-5 hover:bg-gray-200 rounded focus:outline-none focus:bg-blue-600 focus:text-white"
          @click="$emit('close')"
        >
          <svg
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            viewBox="0 0 24 24"
            stroke="currentColor"
            class="w-5 h-5 inline-flex"
          >
            <path d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </li>
      <li class="p-3 bg-gray-200 text-gray-900 rounded" @click="$emit('comments:show')">
        <svg
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          viewBox="0 0 24 24"
          stroke="currentColor"
          class="w-5 h-5 inline-flex"
        >
          <path
            d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2
            2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2
            2 0 01-2 2h-5l-5 5v-5z"
          />
        </svg>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'RightToolbar',
};
</script>
